const prod_config: EnvConfig = {
  verse_os_url: "https://verseos.versemedical.com",
  verse_medical_url: "https://versemedical.com",
  AUTH_DOMAIN: "verse-prod.us.auth0.com",
  AUTH_VM_FE_CLIENT_ID: "Zjc2oV0LZh0mZEBx21GKqouVufSAmrNT",
  AUTH_CLIENT_ID: "dOCTYi1phpyjs3iVaVJmYP84ltGOSHkY",
  AUTH_AUDIENCE: "https://verseos.versemedical.com",
};

const pre_prod_config: EnvConfig = {
  verse_os_url: "https://verseos.pre-prod.versemedical.com",
  verse_medical_url: "https://versemedical.pre-prod.versemedical.com",
  AUTH_DOMAIN: "verse-prod.us.auth0.com",
  AUTH_VM_FE_CLIENT_ID: "Zjc2oV0LZh0mZEBx21GKqouVufSAmrNT",
  AUTH_CLIENT_ID: "dOCTYi1phpyjs3iVaVJmYP84ltGOSHkY",
  AUTH_AUDIENCE: "https://verseos.versemedical.com",
};

const staging_confing: EnvConfig = {
  verse_os_url: "https://verseos.staging.versemedical.com",
  verse_medical_url: "https://versemedical.staging.versemedical.com",
  AUTH_DOMAIN: "verse-staging.us.auth0.com",
  AUTH_VM_FE_CLIENT_ID: "EJqF2OQuSEXUQCkKFTlrSQs8nv8I0bl5",
  AUTH_CLIENT_ID: "HQn7vzSVWnVIMSwQl1B1KfQDmi95BjQZ",
  AUTH_AUDIENCE: "https://verseos.staging.versemedical.com",
};

const staging_2_config: EnvConfig = {
  verse_os_url: "https://verseos.staging-2.versemedical.com",
  verse_medical_url: "https://versemedical.staging-2.versemedical.com",
  AUTH_DOMAIN: "verse-staging.us.auth0.com",
  AUTH_VM_FE_CLIENT_ID: "EJqF2OQuSEXUQCkKFTlrSQs8nv8I0bl5",
  AUTH_CLIENT_ID: "HQn7vzSVWnVIMSwQl1B1KfQDmi95BjQZ",
  AUTH_AUDIENCE: "https://verseos.staging.versemedical.com",
};

const staging_3_config: EnvConfig = {
  verse_os_url: "https://verseos.staging-3.versemedical.com",
  verse_medical_url: "https://versemedical.staging-3.versemedical.com",
  AUTH_DOMAIN: "verse-staging.us.auth0.com",
  AUTH_VM_FE_CLIENT_ID: "EJqF2OQuSEXUQCkKFTlrSQs8nv8I0bl5",
  AUTH_CLIENT_ID: "HQn7vzSVWnVIMSwQl1B1KfQDmi95BjQZ",
  AUTH_AUDIENCE: "https://verseos.staging.versemedical.com",
};

const staging_4_config: EnvConfig = {
  verse_os_url: "https://verseos.staging-4.versemedical.com",
  verse_medical_url: "https://versemedical.staging-4.versemedical.com",
  AUTH_DOMAIN: "verse-staging.us.auth0.com",
  AUTH_VM_FE_CLIENT_ID: "EJqF2OQuSEXUQCkKFTlrSQs8nv8I0bl5",
  AUTH_CLIENT_ID: "HQn7vzSVWnVIMSwQl1B1KfQDmi95BjQZ",
  AUTH_AUDIENCE: "https://verseos.staging.versemedical.com",
};

const dev_config: EnvConfig = {
  verse_os_url: "http://localhost:30000",
  verse_medical_url: "http://localhost:30001",
  AUTH_DOMAIN: "dev-dppbuj1ht4oep8w4.us.auth0.com",
  AUTH_VM_FE_CLIENT_ID: "ECiUgzVATngMM47tFgHiKxSZDmvETFMD",
  AUTH_CLIENT_ID: "xeHS5tZQ2CbYr2Qqpk64p2pxIib5hEcQ",
  AUTH_AUDIENCE: "http://localhost:30000",
};

export interface EnvConfig {
  verse_os_url: string;
  verse_medical_url: string;
  AUTH_DOMAIN: string;
  AUTH_VM_FE_CLIENT_ID: string;
  AUTH_CLIENT_ID: string;
  AUTH_AUDIENCE: string;
}

//TODO once we pass the env variables in non development environments, we can use this function
export async function getConfig(): Promise<EnvConfig> {
  // Added to support shared components in SWO service (temporary fix)
  //@ts-ignore
  const viteEnv = import.meta.env;
  const env = viteEnv ? viteEnv?.VITE_APP_ENV : process.env.REACT_APP_ENV;
  let config: EnvConfig;
  switch (env) {
    case "production":
      config = prod_config;
      break;
    case "pre-production":
      config = pre_prod_config;
      break;
    case "staging":
      config = staging_confing;
      break;
    case "staging-2":
      config = staging_2_config;
      break;
    case "staging-3":
      config = staging_3_config;
      break;
    case "staging-4":
      config = staging_4_config;
      break;
    case "development":
      config = dev_config;
      break;
    default:
      config = dev_config;
  }

  return config;
}

export function isVerseOs(): boolean {
  switch (window.location.origin) {
    case prod_config.verse_os_url:
    case pre_prod_config.verse_os_url:
    case staging_confing.verse_os_url:
    case dev_config.verse_os_url:
      return true;
    default:
      return false;
  }
}

export function isVerseMedical(): boolean {
  switch (window.location.origin) {
    case prod_config.verse_medical_url:
    case pre_prod_config.verse_medical_url:
    case staging_confing.verse_medical_url:
    case dev_config.verse_medical_url:
      return true;
    default:
      return false;
  }
}
